import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { SDialogButton } from './BCommonComponents';
import React from 'react';

export interface ConfirmDialogProps {
	open: boolean;
	onCancel: () => void;
	onConfirm: () => void;
	message: string;
}

export default ConfirmAlertDialog;

function ConfirmAlertDialog(props: ConfirmDialogProps) {
	const {open, onCancel, onConfirm, message} = props;

	const handleCancel = () => {
		onCancel();
	};

	const handleConfirm = () => {
		onConfirm();
	};

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleCancel}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{"ATTENZIONE"}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{message}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<SDialogButton onClick={handleConfirm}>
						CONFERMA
					</SDialogButton>
					<SDialogButton onClick={handleCancel} variantcolor="secondary">
						ANNULLA
					</SDialogButton>
				</DialogActions>
			</Dialog>
		</div>
	);
}
